import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Box} from '@mui/material';
import loaderGif from "./../Assests/loader.gif";
const FacilityTypeFormDialog = ({ open, handleClose, handleSave, initialData }) => {
  const initialFormData = {
    facility_type_id: '',
    name: '',
    description : '',
  };

  const [formData, setFormData] = useState(initialFormData);
  const [fieldErrors, setFieldErrors] = useState ({}); // State to track field errors
  const [isSaving, setIsSaving] = useState(false);
  // Update formData whenever initialData changes or reset it if initialData is null (adding a new record)
  useEffect(() => {
    // Reset the field errors every time the dialog is opened
  setFieldErrors({});
   if (initialData) {
     setFormData(initialData);
   } else {
     setFormData(initialFormData);
   }
   // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [initialData, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const validateForm = () => {
    const errors = {};
        // Facility Name validation
        if (!formData.name) {
          errors.name = 'FacilityType Name is required';
        } else if (typeof formData.name !== 'string') {
          errors.name = 'FacilityType Name must be a string';
        }
      
        // Address validation
        if (!formData.description) {
          errors.description = 'description is required';
        } else if (typeof formData.description !== 'string') {
          errors.description = 'description must be a string';
        }
    setFieldErrors (errors);

    // Return true if no errors
    return Object.keys (errors).length === 0;
  };
  const onSave = async() => {
    if (validateForm (formData)) {
      setIsSaving(true);
      try{
      await handleSave (formData);
      handleClose ();
    }catch(error){  
      console.error ("Error saving Facility Type:", error);
    }finally{
      setIsSaving(false);
    }
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle className='modal-header'>{initialData ? 'Update Facility Type' : 'Add New Facility Type'}</DialogTitle>
      {isSaving && (
        <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        display="flex"
        justifyContent="center"
        alignItems="center"
        bgcolor="rgba(255, 255, 255, 0.8)"
        zIndex={1}
      >
        <img src={loaderGif} alt="Loading..." width={50} height={50} />
      </Box>
      )}
      <DialogContent>
        <TextField
          margin="dense"
          name="name"
          label="Facility Type Name"
          fullWidth
          variant="outlined"
          value={formData.name}
          onChange={handleChange}
          disabled={!!initialData}
        
        />
         {fieldErrors.name &&
          <div style={{color: 'red', fontSize: '0.875rem'}}>
            {fieldErrors.name}
          </div>}
        <TextField
          margin="dense"
          name="description"
          label="Description"
          fullWidth
          variant="outlined"
          value={formData.description}
          onChange={handleChange}
        />
         {fieldErrors.description &&
          <div style={{color: 'red', fontSize: '0.875rem'}}>
            {fieldErrors.description}
          </div>}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={onSave} color="primary" variant="contained">
            {initialData ? 'Update' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FacilityTypeFormDialog;